<button type="button" 
        class="btn btn-view-document" 
        data-bs-toggle="modal" 
        [attr.data-bs-target]="'#'+ id"
        *ngIf="!hideButton">
  <i class="fas fa-eye"></i>
  <span>View</span>
</button>

<!-- PDF Viewer Modal -->
<div class="modal fade pdf-modal" 
     id="{{id}}" 
     tabindex="-1" 
     role="dialog" 
     [attr.aria-labelledby]="id+'-Title'"
     aria-hidden="true">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-title-wrapper">
          <i class="fas fa-file-pdf pdf-icon"></i>
          <h5 class="modal-title" [id]="id+'Title'">{{title}}</h5>
        </div>
        <button type="button" class="close-button" data-bs-dismiss="modal" aria-label="Close">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="pdf-container">
          <embed [src]='photoURL(url)' 
                 type="application/pdf" 
                 class="pdf-embed">
          <div class="pdf-fallback">
            <i class="fas fa-file-pdf"></i>
            <p>Unable to display PDF file.</p>
            <a [href]="url" target="_blank" class="btn btn-download">
              <i class="fas fa-download"></i> Download PDF
            </a>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <a [href]="url" 
           download 
           class="btn btn-download-footer">
          <i class="fas fa-download"></i> Download
        </a>
        <a [href]="url" 
           target="_blank" 
           class="btn btn-open-new">
          <i class="fas fa-external-link-alt"></i> Open in New Tab
        </a>
        <button type="button" 
                class="btn btn-close-footer" 
                data-bs-dismiss="modal">
          <i class="fas fa-times"></i> Close
        </button>
      </div>
    </div>
  </div>
</div>